/* tslint:disable */
/* eslint-disable */
/**
 * Muisti API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PageLayoutViewPropertyType,
    PageLayoutViewPropertyTypeFromJSON,
    PageLayoutViewPropertyTypeFromJSONTyped,
    PageLayoutViewPropertyTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface PageLayoutViewProperty
 */
export interface PageLayoutViewProperty {
    /**
     * 
     * @type {string}
     * @memberof PageLayoutViewProperty
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PageLayoutViewProperty
     */
    value: string;
    /**
     * 
     * @type {PageLayoutViewPropertyType}
     * @memberof PageLayoutViewProperty
     */
    type: PageLayoutViewPropertyType;
}

export function PageLayoutViewPropertyFromJSON(json: any): PageLayoutViewProperty {
    return PageLayoutViewPropertyFromJSONTyped(json, false);
}

export function PageLayoutViewPropertyFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageLayoutViewProperty {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'value': json['value'],
        'type': PageLayoutViewPropertyTypeFromJSON(json['type']),
    };
}

export function PageLayoutViewPropertyToJSON(value?: PageLayoutViewProperty | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'value': value.value,
        'type': PageLayoutViewPropertyTypeToJSON(value.type),
    };
}


